import { type FC } from "react";

import { type MeFragment } from "@app_schema";

export const MenuProfileGroup: FC<{
  me: MeFragment;
}> = ({ me }) => {
  const organization = me.organizations.find(({ current }) => current);
  if (!organization) return;

  return (
    <div className="truncate text-xs font-light text-slate-500">
      {organization.name}
    </div>
  );
};
